import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { t } from 'i18next';

import { initialPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';
import { prefix, REVENUE_PLAN_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/RevenuePlan/utils/form';
import { GLOBAL_PRODUCTS_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

export const NET_SALES_NAMES = {
  NET_SALES: 'netSales',
  INCOME: 'income',
  COST_OF_SALES: 'costOfSales',
  GROSS_PROFIT: 'grossProfit',
} as const;

export const netSalesLinkedFieldNames = {
  revenuePlanRowTitleName: GLOBAL_PRODUCTS_NAME,
  otherIncomeName: concatWithDot(prefix, REVENUE_PLAN_NAMES.PLANNED_PRODUCTS_VOLUME_OTHER_INCOME),
};

export const useGetNetSalesTableHeadings = () => {
  const { t, i18n } = useTranslation();
  return useMemo(() => {
    const OTHER_INCOME = t('otherIncome');

    const totalRowTitle = t('financialPlan.profitAndLossProjection.netSales.grossProfit');
    const costOfSalesRowTitle = t('financialPlan.plannedExpenses.costOfSales.expectedRowTitle');
    const netSalesRowTitle = t('financialPlan.profitAndLossProjection.netSales.netSalesRevenue');
    return { OTHER_INCOME, totalRowTitle, costOfSalesRowTitle, netSalesRowTitle };
  }, [t, i18n]);
};

export const netSalesInitialValues = {
  [NET_SALES_NAMES.COST_OF_SALES]: initialPeriodsTableRow,
  [NET_SALES_NAMES.GROSS_PROFIT]: initialPeriodsTableRow,
  [NET_SALES_NAMES.NET_SALES]: initialPeriodsTableRow,
  [NET_SALES_NAMES.INCOME]: initialPeriodsTableRow,
};
